import { ApiResponse } from "../../../types";
import { getRequestWithAuth, getRequestWithQuery } from "../configuration";
import getApiWithVersion from "../apis";
import { API_VERSION } from "../../constants/common";

const api = getApiWithVersion(API_VERSION.V1)

export interface API_Warehouse{
    getPickupSlot(pincode:string):Promise<ApiResponse<[]>>
}

const warehouse:API_Warehouse={
    getPickupSlot(pincode:string){
         let fromDate = new Date(new Date().setDate(new Date().getDate() + 2))
      .toISOString()
      .split("T")[0];
      const query = {from_date: fromDate , pincode:pincode }
        return getRequestWithAuth(api.ORDER_SCHEDULE_DATE, undefined, query )
    }
}

export default warehouse